// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9721a396","308":"4aaa99f4","650":"f7000aa3","667":"ef22a885"}[chunkId] + ".chunk.js";
};